import {createSvgIcon} from '@ui/icons/create-svg-icon';

export const MediaPlayIcon = createSvgIcon(
  <path d="M10.6667 6.6548C10.6667 6.10764 11.2894 5.79346 11.7295 6.11862L24.377 15.4634C24.7377 15.7298 24.7377 16.2692 24.3771 16.5357L11.7295 25.8813C11.2895 26.2065 10.6667 25.8923 10.6667 25.3451L10.6667 6.6548Z" />,
  'MediaPlay',
  '0 0 32 32',
);
